import Globe from '../../src/legacy/Globe.tsx';
export default Globe;
